const f = {
  edit: param => {
    console.log(`edit ${param}.`)
  },
  clone: param => {
    console.log(`clone ${param}.`)
  },
  delete: param => {
    console.log(`delete ${param}.`)
  }
}

export default {
  install (vue) {
    vue.actions = f
    vue.prototype.$actions = f
  }
}
